import HeaderLogged from "components/Header/HeaderLogged";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SiteHeader = () => {
  let pathname = useLocation().pathname;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return <HeaderLogged />;
};
export default SiteHeader;
